// Verità sull'accesso Premium, prima di dirla allo studente.
//
// Due campi del documento studente NON provano un pagamento, perché vengono
// scritti PRIMA del redirect a Stripe, per chiunque scelga un piano nell'onboarding:
//   - `source: 'welcome_flow_checkout'`
//   - `needsPasswordSetup: true`
// Chi esce dal checkout senza pagare li ha tutti e due. Dal 26/11/2025 al 08/09/2026
// quei due campi bastavano a mostrare «Sei dentro, Premium è attivo» a 258 persone
// che non avevano pagato (STU-315).

export const hasEntitlement = (userData) =>
  !!userData && (
    userData.plan === 'Premium' ||
    userData.trialStartedAt != null ||
    userData.subscriptionStartedAt != null ||
    userData.is_parent_account === true ||
    userData.subscription_type === 'gift'
  );

// Esito da mostrare su /payment-completed.
//   confirmed  → «Sei dentro»: entitlement letto, oppure ruolo che non compra per sé
//   free       → ha scelto il gratuito dall'offerta (?piano=gratuito) con un account
//                nato nel checkout: qui non si paga, si imposta la password e si entra
//   pending    → torna da Stripe (session_id) ma il webhook non ha ancora scritto:
//                si aspetta, non si promette
//   not_paid   → nessun session_id e nessun entitlement: è arrivato qui senza pagare
// L'ordine conta: la scelta esplicita del gratuito viene prima del ruolo, altrimenti
// un genitore che sceglie il gratuito leggerebbe «Premium è attivo».
export const resolveOutcome = ({ sessionId, role, userData, premiumConfirmed, freeChoice = false }) => {
  if (premiumConfirmed || hasEntitlement(userData)) return 'confirmed';
  if (freeChoice && !sessionId) return 'free';
  if (role === 'parent' || role === 'gift' || role === 'teacher') return 'confirmed';
  return sessionId ? 'pending' : 'not_paid';
};

// Dove va, al caricamento di una pagina qualsiasi, un account nato DENTRO il checkout
// dell'onboarding (`needsPasswordSetup: true`). Due cose sono vere di quell'account:
// esiste PRIMA che ci sia una carta, e ha una password temporanea che la persona non
// conosce. Finché non c'è un entitlement non deve entrare nell'app (STU-322: chi usciva
// da Stripe finiva su /home da gratuito, con l'email non verificata).
//   'password' → ha l'accesso: /payment-completed, che gestisce il form della password
//   'offerta'  → è dentro l'app senza aver pagato: torna all'offerta, dove può ripagare
//                o scegliere il gratuito
//   'ferma'    → è già fuori dall'app: resta dov'è, nessun trascinamento
//   null       → non è un account del checkout, o è sulla pagina che si gestisce da
//                sola: percorso normale
export const rottaAccountDaCheckout = ({ needsPasswordSetup, entitled, currentPath = '' }) => {
  if (!needsPasswordSetup) return null;
  if (currentPath === '/payment-completed') return null;
  if (entitled) return 'password';
  return currentPath.startsWith('/home') ? 'offerta' : 'ferma';
};
